module.exports = __webpack_public_path__ + "media/fonts/TTCommons-Regular-7f6a692400ad7453ffb3779adb81ea02.woff";